import { Dispatch, SetStateAction, useEffect, useState } from "react";

import SpecialistApi from "../../../../api/specialistsApi";
import { ReactComponent as DeleteIcon } from "../../../../assets/General/close.svg";
import { ReactComponent as PlusIcon } from "../../../../assets/General/plus.svg";
import Input from "../../../../components/Input/Input";
import MuiSwitch from "../../../../components/MuiSwitch/MuiSwitch";
import MultipleSelect from "../../../../components/MultipleSelect/MultipleSelect";
import StandartButton from "../../../../components/StandartButton/StandartButton";
import { network } from "../../../../config";
import { imageExtensions } from "../../../../constans/filesExtensions";
import { siteLangs } from "../../../../constans/siteLangs";
import {
  Education,
  EducationAccreditation,
  Federation,
  Qualification,
} from "../../../../types/TypeSpecialist";
import { TypeUpdatedUserInfo } from "../../../../types/TypeUsers";
import { compressFiles } from "../../../../utils/compressionFile";
import url from "../../../../utils/formApiUrl";
import Notify, { SuccesNotify } from "../../../../utils/toaster";
import {
  areAllTextFieldsFilled,
  validateURL,
} from "../../../../utils/validations";
import s from "../AddCertificatesModal.module.css";

const { specialists } = network;
const connectionString = process.env.REACT_APP_HTTP_CONNECTION_STRING;

type FederationsCertificates = {
  setActionLoaders: Dispatch<SetStateAction<{ addedCertificate: boolean }>>;
  setModalOpen: Dispatch<SetStateAction<boolean>>;
  specializationsData: { lable: string; value: string }[];
  setCertificatesData: Dispatch<
    SetStateAction<{
      educations: Education[];
      qualifications: Qualification[];
      federations: Federation[];
    }>
  >;
  educationToUpdate?: Education;
  coursesToUpdate?: CoursesToUpdate[];
  setCoursesData?: Dispatch<SetStateAction<CoursesToUpdate[]>>;
  setUpdateDataTriger?: React.Dispatch<React.SetStateAction<number>>;
};

type CoursesToUpdate = {
  accreditations: (EducationAccreditation | undefined)[];
  _id: string;
  text: {
    language: string;
    text: string;
  }[];
  isShown: boolean;
  education: Education;
  deleted: boolean;
};

type NewEducation = {
  newEducation: {
    educationText: { text: string; language: string }[];
    newCoursesAndAccr: {
      courseText: { text: string; language: string }[];
      isVerifiedCourse: boolean;
      accreditations: {
        text: { text: string; language: string }[];
        isShown: boolean;
        badge?: {
          file: File;
          url?: string;
        };
      }[];
    }[];
    prevCourseAndAccr?: CoursesToUpdate[];
    specialization: string | undefined;
    isShown: boolean;
  };
};

type NewAccrForPrevCourse = {
  courseId: string;
  text: {
    text: string;
    language: string;
  }[];
  isShown: boolean;
  badge?: {
    file: File;
    url?: string;
  };
};

const emptyMultiLangStrings = [
  { text: "", language: "en" },
  { text: "", language: "ru" },
  { text: "", language: "uk" },
];

const initialEducation: NewEducation = {
  newEducation: {
    educationText: emptyMultiLangStrings,
    newCoursesAndAccr: [
      {
        courseText: emptyMultiLangStrings,
        isVerifiedCourse: true,
        accreditations: [{ text: emptyMultiLangStrings, isShown: true }],
      },
    ],
    prevCourseAndAccr: undefined,
    specialization: undefined,
    isShown: true,
  },
};

const EducationsCertificates = ({
  setActionLoaders,
  setModalOpen,
  specializationsData,
  setCertificatesData,
  educationToUpdate,
  coursesToUpdate,
  setCoursesData,
  setUpdateDataTriger,
}: FederationsCertificates) => {
  const token = localStorage.getItem("token");
  const [selecLangForText, setSelecLangForText] = useState("en");
  const [addEducation, setAddEducation] =
    useState<NewEducation>(initialEducation);
  const [newAccrForPrevCourses, setNewAccrForPrevCourses] = useState<
    NewAccrForPrevCourse[] | undefined
  >();
  const [badgesToUpdate, setBadgesToUpdate] = useState<{
    [key: string]: {
      _id: string;
      file?: File | string;
      url?: string;
    };
  }>({});
  const [newBadgesForPrevAccr, setNewBadgesForPrevAccr] = useState<
    { accrId: string; file?: File; url?: string }[]
  >([]);

  useEffect(() => {
    function filterByLanguage(
      array1: { text: string; language: string }[],
      array2: { text: string; language: string }[],
    ): { text: string; language: string }[] {
      // Получаем список всех языков из второго массива
      const languagesToRemove = new Set(array2.map((item) => item.language));

      // Фильтруем первый массив, исключая элементы с совпадающим language
      return array1.filter((item) => !languagesToRemove.has(item.language));
    }
    if (!educationToUpdate) return;

    const newLang = filterByLanguage(
      emptyMultiLangStrings,
      educationToUpdate.text,
    );
    setAddEducation((prev) => ({
      ...prev,
      newEducation: {
        educationText: [...educationToUpdate.text, ...newLang],
        newCoursesAndAccr: [
          /*   {
            courseText: emptyMultiLangStrings,
            accreditationText: [emptyMultiLangStrings],
          }, */
        ],
        prevCourseAndAccr: coursesToUpdate,
        specialization: educationToUpdate.specialization._id,
        isShown: educationToUpdate.isShown,
      },
    }));
  }, [educationToUpdate]);

  const createEducation = async () => {
    if (!token) return;
    const payload = {
      educationText: addEducation.newEducation.educationText,
      specialization: addEducation.newEducation.specialization!,
      isShown: addEducation.newEducation.isShown,
    };
    const response = await SpecialistApi.createEducation(token, payload);
    if (!response.status && response.message) {
      Notify(response.message);
    }
    if (response.status && response.education) {
      setCertificatesData((prev) => ({
        ...prev,
        educations: [response.education!, ...prev.educations],
      }));
    }
    return { status: response.status, educationId: response.education?._id };
  };

  const updateEducationCourse = async (updateData: TypeUpdatedUserInfo) => {
    if (!educationToUpdate || !token) return;
    const response = await SpecialistApi.updateEducationCourse(
      token,
      updateData,
    );

    if (response.status && response.course && setCoursesData) {
      setCoursesData((prev) =>
        prev.map((item) => {
          if (item._id === response.course?._id) {
            return response.course as CoursesToUpdate;
          }
          return item;
        }),
      );
    }
    if (!response.status && response.message) {
      Notify(response.message);
    }
    return response;
  };

  const updateBadge = async (updateData: {
    _id: string;
    file?: File | string;
    url?: string;
  }) => {
    if (!token) return;
    const updateBadgeData = {
      _id: updateData._id,
      url: updateData.url,
    };
    const formData = new FormData();

    formData.append("updateData", JSON.stringify(updateBadgeData));
    if (updateData.file && typeof updateData.file !== "string") {
      formData.append("file", updateData.file);
    }

    const response = await SpecialistApi.updateFederationBadge(token, formData);

    if (!response.status && response.message) {
      Notify(response.message);
    }
    return { status: response.status, badgeId: response.badge?._id };
  };

  const updateEducationAccreditation = async (
    updateData: TypeUpdatedUserInfo,
  ) => {
    if (!educationToUpdate || !token) return;
    const response = await SpecialistApi.updateEducationAccreditation(
      token,
      updateData,
    );

    if (
      response.status &&
      response.accreditation &&
      setCoursesData &&
      coursesToUpdate
    ) {
      const updatedCoursesAndAccr = coursesToUpdate.map((item) => {
        if (item._id === response.accreditation?.educationCourse._id) {
          return {
            ...item,
            accreditations: item.accreditations.map((accr) => {
              if (accr?._id === response.accreditation?._id) {
                return response.accreditation;
              }
              return accr;
            }),
          };
        }
        return item;
      });

      setCoursesData(updatedCoursesAndAccr);
    }
    if (!response.status && response.message) {
      Notify(response.message);
    }
    return response;
  };

  const updateCoursesAndAccr = async () => {
    if (!addEducation.newEducation.prevCourseAndAccr) return;
    const promisesCourses = addEducation.newEducation.prevCourseAndAccr.map(
      async (item) => {
        const updateDataCourse = {
          _id: item._id,
          deleted: item.deleted,
          text: item.text,
          isShown: item.isShown,
        };
        const courseResponse = await updateEducationCourse(updateDataCourse);
        if (!item.accreditations) return courseResponse?.status;
        const promisesAccr = item.accreditations.map(async (accrItem) => {
          let newwBadgeId: string | undefined;
          const newBadge = newBadgesForPrevAccr.find(
            (el) => el.accrId === accrItem!._id,
          );
          if (newBadge?.file) {
            const createBadgeResponse = await createAccrBadge({
              file: newBadge.file,
              url: newBadge.url,
            });
            if (createBadgeResponse?.status && createBadgeResponse.badgeId) {
              newwBadgeId = createBadgeResponse.badgeId;
            }
          }
          const updateDataAccr = {
            _id: accrItem!._id,
            text: accrItem!.text,
            badge: newwBadgeId,
            deleted: accrItem?.deleted,
            isShown: accrItem?.isShown,
          };
          const accrResponse =
            await updateEducationAccreditation(updateDataAccr);
          return accrResponse!.status;
        });
        const accrResults = await Promise.all(promisesAccr);
        return [...accrResults, courseResponse!.status!];
      },
    );
    if (badgesToUpdate) {
      const badgeUpdateData = Object.entries(badgesToUpdate).map(
        ([_, value]) => {
          return updateBadge(value);
        },
      );
      await Promise.all(badgeUpdateData);
    }
    const results = await Promise.all(promisesCourses);

    return results as boolean[];
  };

  const updateEducation = async () => {
    if (!token || !educationToUpdate) return;
    const educationData = addEducation.newEducation;
    if (
      educationData.newCoursesAndAccr &&
      educationData.newCoursesAndAccr.length
    ) {
      await createCoursesAndAccr(educationToUpdate._id);
    }
    if (newAccrForPrevCourses && newAccrForPrevCourses.length) {
      const newAccrForPrevCoursesPromises = newAccrForPrevCourses.map(
        async (item) => {
          const response = await createEducationAccreditation(
            item.courseId,
            item,
          );
          return response;
        },
      );
      await Promise.all(newAccrForPrevCoursesPromises);
    }
    await updateCoursesAndAccr();
    const updateData = {
      _id: educationToUpdate._id,
      text: educationData.educationText,
      specialization: educationData.specialization,
      isShown: educationData.isShown,
    };

    const updateEducationResponse = await SpecialistApi.updateEducation(
      token,
      updateData,
    );

    if (updateEducationResponse.status && updateEducationResponse.education) {
      SuccesNotify("Education has been updated");
      setAddEducation(initialEducation);
      setModalOpen(false);
      /*    setCertificatesData((prev) => ({
        ...prev,
        educations: prev.educations.map((item) => {
          if (item._id === updateEducationResponse.education?._id) {
            return updateEducationResponse.education;
          }
          return item;
        }),
      })); */

      setUpdateDataTriger && setUpdateDataTriger((prev) => prev + 1);
    }
  };

  const createEducationCourse = async (
    educationId: string,
    courseText: { text: string; language: string }[],
    isShown: boolean,
  ) => {
    if (!token) return;
    const payload = {
      courseText: courseText,
      educationId: educationId,
      isShown: isShown,
    };
    const response = await SpecialistApi.createEducationCourse(token, payload);

    if (response.status && response.course) {
      return response.course._id;
    }
    if (!response.status && response.message) {
      Notify(response.message);
    }
    return undefined;
  };

  const createAccrBadge = async (badge: { file: File; url?: string }) => {
    if (!token) return;
    const formData = new FormData();

    formData.append("file", badge.file!);
    if (badge.url) {
      formData.append("url", badge.url!);
    }

    const response = await SpecialistApi.createFederationBadge(token, formData);

    if (!response.status && response.message) {
      Notify(response.message);
    }
    return { status: response.status, badgeId: response.badge?._id };
  };

  const createEducationAccreditation = async (
    courseId: string,
    accreditation: {
      text: {
        text: string;
        language: string;
      }[];
      isShown: boolean;
      badge?: {
        file: File;
        url?: string;
      };
    },
  ) => {
    if (!token) return;
    let badgeId: string | undefined;
    if (accreditation.badge) {
      const response = await createAccrBadge(accreditation.badge);
      if (response?.status && response.badgeId) {
        badgeId = response.badgeId;
      }
    }
    const payload = {
      accreditationText: accreditation.text,
      courseId: courseId,
      isShown: accreditation.isShown,
      badgeId: badgeId,
    };
    const response = await SpecialistApi.createEducationAccreditation(
      token,
      payload,
    );

    if (response.status && response.accreditation) {
      return response.accreditation._id;
    }
    if (!response.status && response.message) {
      Notify(response.message);
    }
    return undefined;
  };

  const createCoursesAndAccr = async (educationId: string) => {
    const promises = addEducation.newEducation.newCoursesAndAccr.map(
      async (item) => {
        const courseResponse = await createEducationCourse(
          educationId,
          item.courseText,
          true,
        );

        if (
          courseResponse &&
          areAllTextFieldsFilled(
            item.accreditations.map((item) => item.text).flat(),
          )
        ) {
          const accrResponses = item.accreditations.map(async (accrItem) => {
            await createEducationAccreditation(courseResponse, accrItem);
          });
          return accrResponses;
        } else if (courseResponse) {
          return true;
        }
        return false;
      },
    );

    // Дождаться выполнения всех промисов и вернуть массив булевых значений
    const results = await Promise.all(promises);
    return results;
  };

  const saveEducation = async () => {
    if (!token) return;
    setActionLoaders((prev) => ({ ...prev, addedCertificate: true }));
    let educationId: string | undefined = undefined;
    const educationResponse = await createEducation();
    educationId = educationResponse?.educationId;
    if (!educationId) return;
    const coursesAndAccrResponses = await createCoursesAndAccr(educationId);
    if (!coursesAndAccrResponses.includes(false)) {
      SuccesNotify("Education has been added");
      setAddEducation(initialEducation);
      setModalOpen(false);
    }
    setActionLoaders((prev) => ({ ...prev, addedCertificate: false }));
  };

  const validationNewCertificate = () => {
    const newEducation = addEducation.newEducation;
    const validateCuorses = newEducation.newCoursesAndAccr.map((item) => {
      return areAllTextFieldsFilled(item.courseText);
    });
    if (
      !areAllTextFieldsFilled(newEducation.educationText) ||
      !newEducation.specialization ||
      validateCuorses.includes(false)
    )
      return false;
    return true;
  };

  const getPlaceHolder = (textArr: { text: string; language: string }[]) => {
    const filteredText = textArr.filter(
      (el) => el.language !== selecLangForText,
    );
    let result: string = "";
    for (const text of filteredText) {
      if (text.text.length) {
        result = text.language.toUpperCase() + ": " + text.text;
        break;
      }
    }
    return result;
  };

  const handleBadgeIconChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
    setFile: (file: File) => void,
  ) => {
    if (event.target && event.target.files) {
      const file = event.target.files[0];

      if (file) {
        const compressedFile = await compressFiles(file);
        if (compressedFile.file) {
          setFile(compressedFile.file);
        }
      }
    }
  };

  const getBadgeForAccrToUpdate = (courseId: string, accrId: string) => {
    const prevBadge =
      addEducation.newEducation.prevCourseAndAccr &&
      addEducation.newEducation.prevCourseAndAccr
        .find((el) => el._id === courseId)
        ?.accreditations.find((el) => el?._id === accrId)?.badge;
    const badgeToUpdate = prevBadge && badgesToUpdate[prevBadge?._id];
    const newBadgeForPrevAccr = newBadgesForPrevAccr.find(
      (el) => el.accrId === accrId,
    );

    if (prevBadge) {
      return (
        badgeToUpdate || {
          file: prevBadge.fileS3 || prevBadge.link,
          url: prevBadge.url,
        }
      );
    }
    return newBadgeForPrevAccr;
  };

  return (
    <div className={`${s.container} ${s.federationContainer}`}>
      <div className={s.langsBlock}>
        {siteLangs.map((item, index) => (
          <div
            key={index}
            className={
              selecLangForText === item.value ? s.activeTab : s.notActiveTab
            }
            onClick={() => setSelecLangForText(item.value)}
          >
            {item.lable}
            {selecLangForText === item.value && (
              <span className={s.tabIndicator}></span>
            )}
          </div>
        ))}
      </div>
      <div className={s.newEducationBlock}>
        <Input
          inputValue={
            addEducation.newEducation.educationText.find(
              (el) => el.language === selecLangForText,
            )?.text || ""
          }
          isVisible
          required
          placeholder={getPlaceHolder(addEducation.newEducation.educationText)}
          onChangeInput={(value) =>
            setAddEducation((prev) => ({
              ...prev,
              newEducation: {
                ...prev.newEducation,
                educationText: prev.newEducation.educationText.map((item) => {
                  if (item.language === selecLangForText) {
                    return {
                      text: value,
                      language: item.language,
                    };
                  } else return item;
                }),
              },
            }))
          }
          lable={"Education title"}
          margin="0"
          width="45%"
        />
        <div style={{ width: "45%" }}>
          <span className={s.secondLable}>Specialization</span>
          <MultipleSelect
            data={specializationsData}
            multiplie={false}
            setValue={(value) =>
              setAddEducation((prev) => ({
                ...prev,
                newEducation: {
                  ...prev.newEducation,
                  specialization: value as string,
                },
              }))
            }
            value={addEducation.newEducation.specialization ?? ""}
          />
        </div>
        <div>
          <span className={s.secondLable}>Is verified education?</span>
          <MuiSwitch
            checked={addEducation.newEducation.isShown}
            setChecked={(value) =>
              setAddEducation((prev) => ({
                ...prev,
                newEducation: { ...prev.newEducation, isShown: value },
              }))
            }
          />
        </div>
      </div>
      <div>
        <div className={s.rowBeetween}>
          <span className={s.secondLable}>Courses and Accreditation</span>
          <StandartButton
            buttonTitle="Add course"
            action={() =>
              setAddEducation((prev) => ({
                ...prev,
                newEducation: {
                  ...prev.newEducation,
                  newCoursesAndAccr: [
                    {
                      courseText: emptyMultiLangStrings,
                      isVerifiedCourse: true,
                      accreditations: [
                        { text: emptyMultiLangStrings, isShown: true },
                      ],
                    },
                    ...prev.newEducation.newCoursesAndAccr,
                  ],
                },
              }))
            }
          />
        </div>
        <div className={s.coursesList}>
          {addEducation.newEducation.newCoursesAndAccr &&
            addEducation.newEducation.newCoursesAndAccr.map((item, index) => (
              <div className={s.courseAccrElement} key={index}>
                <div
                  className={s.deleteBtn}
                  onClick={() => {
                    if (
                      addEducation.newEducation.newCoursesAndAccr.length +
                        (addEducation.newEducation.prevCourseAndAccr
                          ? addEducation.newEducation.prevCourseAndAccr.length
                          : 0) ===
                      1
                    )
                      return;

                    setAddEducation((prev) => ({
                      ...prev,
                      newEducation: {
                        ...prev.newEducation,
                        newCoursesAndAccr:
                          prev.newEducation.newCoursesAndAccr.filter(
                            (_, indexToRemove) => index !== indexToRemove,
                          ),
                      },
                    }));
                  }}
                >
                  <DeleteIcon className={s.closeIcon} />
                </div>
                <div className={s.flex20Gap} style={{ marginTop: "20px" }}>
                  <Input
                    inputValue={
                      item.courseText.find(
                        (el) => el.language === selecLangForText,
                      )?.text || ""
                    }
                    isVisible
                    required
                    placeholder={getPlaceHolder(item.courseText)}
                    onChangeInput={(value) =>
                      setAddEducation((prev) => ({
                        ...prev,
                        newEducation: {
                          ...prev.newEducation,
                          newCoursesAndAccr:
                            prev.newEducation.newCoursesAndAccr.map(
                              (el, i) => ({
                                accreditations: el.accreditations,
                                isVerifiedCourse: el.isVerifiedCourse,
                                courseText:
                                  index !== i
                                    ? el.courseText
                                    : el.courseText.map((textItem) => {
                                        if (
                                          textItem.language === selecLangForText
                                        ) {
                                          return {
                                            text: value,
                                            language: textItem.language,
                                          };
                                        } else return textItem;
                                      }),
                              }),
                            ),
                        },
                      }))
                    }
                    lable={"Course title"}
                    margin="0 0 20px 0"
                    width="80%"
                  />
                  <div>
                    <span className={s.secondLable}>Is verified course?</span>
                    <MuiSwitch
                      checked={item.isVerifiedCourse}
                      setChecked={(value) =>
                        setAddEducation((prev) => ({
                          ...prev,
                          newEducation: {
                            ...prev.newEducation,
                            newCoursesAndAccr:
                              prev.newEducation.newCoursesAndAccr.map(
                                (el, i) => ({
                                  accreditations: el.accreditations,
                                  isVerifiedCourse: value,
                                  courseText: el.courseText,
                                }),
                              ),
                          },
                        }))
                      }
                    />
                  </div>
                </div>
                <div className={s.flex20Gap} style={{ margin: "15px 0" }}>
                  <span className={s.blockLabel}>Accreditations</span>{" "}
                  <div
                    className={s.addAccrBtn}
                    onClick={() =>
                      setAddEducation((prev) => ({
                        ...prev,
                        newEducation: {
                          ...prev.newEducation,
                          newCoursesAndAccr:
                            prev.newEducation.newCoursesAndAccr.map(
                              (courseItem, courseIndex) => {
                                if (index === courseIndex) {
                                  return {
                                    ...courseItem,
                                    accreditations: [
                                      ...courseItem.accreditations,
                                      {
                                        text: emptyMultiLangStrings,
                                        isShown: true,
                                      },
                                    ],
                                  };
                                } else return courseItem;
                              },
                            ),
                        },
                      }))
                    }
                  >
                    <PlusIcon />
                  </div>
                </div>
                <table className={s.table}>
                  <thead className={s.thead}>
                    <tr>
                      <th className={s.th}>Title</th>
                      <th className={s.th}>Badge</th>
                      <th className={s.th}>Is Verified</th>
                    </tr>
                  </thead>
                  <tbody>
                    {item.accreditations &&
                      item.accreditations.map((accrItem, idx) => (
                        <tr key={idx}>
                          <td className={s.td}>
                            <Input
                              inputValue={
                                accrItem?.text.find(
                                  (el) => el.language === selecLangForText,
                                )?.text || ""
                              }
                              isVisible
                              required
                              placeholder={getPlaceHolder(accrItem?.text ?? [])}
                              onChangeInput={(value) =>
                                setAddEducation((prev) => ({
                                  ...prev,
                                  newEducation: {
                                    ...prev.newEducation,
                                    newCoursesAndAccr:
                                      prev.newEducation.newCoursesAndAccr.map(
                                        (el, i) => ({
                                          ...el,
                                          accreditations:
                                            index !== i
                                              ? el.accreditations
                                              : el.accreditations.map(
                                                  (accrArray, accIndex) =>
                                                    accIndex !== idx
                                                      ? accrArray
                                                      : {
                                                          ...accrArray,
                                                          text: accrArray.text.map(
                                                            (textItem) =>
                                                              textItem.language ===
                                                              selecLangForText
                                                                ? {
                                                                    ...textItem,
                                                                    text: value,
                                                                  }
                                                                : textItem,
                                                          ),
                                                        },
                                                ),
                                        }),
                                      ),
                                  },
                                }))
                              }
                              margin="10px 0"
                            />
                          </td>
                          <td className={s.td}>
                            <div className={s.uploadFilesActionBlock}>
                              <div>
                                {accrItem.badge && (
                                  <img
                                    src={
                                      typeof accrItem.badge === "string"
                                        ? url(
                                            `${connectionString}specialists/`,
                                            specialists.getFederationBadgeStream,
                                            { id: accrItem.badge },
                                          )
                                        : URL.createObjectURL(
                                            accrItem.badge.file,
                                          )
                                    }
                                    alt=""
                                    className={s.badgeIcon}
                                  />
                                )}
                              </div>
                              <label className={s.fileInputBlock}>
                                <input
                                  style={{ display: "none" }}
                                  type="file"
                                  accept={imageExtensions.join(", ")}
                                  multiple
                                  onChange={(e) =>
                                    handleBadgeIconChange(e, (file: File) => {
                                      setAddEducation((prev) => ({
                                        ...prev,
                                        newEducation: {
                                          ...prev.newEducation,
                                          newCoursesAndAccr:
                                            prev.newEducation.newCoursesAndAccr.map(
                                              (el, i) => ({
                                                ...el,
                                                accreditations:
                                                  index !== i
                                                    ? el.accreditations
                                                    : el.accreditations.map(
                                                        (
                                                          accrArray,
                                                          accIndex,
                                                        ) =>
                                                          accIndex !== idx
                                                            ? accrArray
                                                            : {
                                                                ...accrArray,
                                                                badge: {
                                                                  file: file,
                                                                },
                                                              },
                                                      ),
                                              }),
                                            ),
                                        },
                                      }));
                                    })
                                  }
                                />
                                {accrItem.badge ? (
                                  <span
                                    className={s.updateAvatarBtn}
                                    role="button"
                                  >
                                    <span>Replace</span>
                                  </span>
                                ) : (
                                  <div className={s.addCertificateBtn}>
                                    <PlusIcon className={s.plusIcon} />
                                    <span>Add badge</span>
                                  </div>
                                )}
                              </label>
                              {accrItem.badge && (
                                <Input
                                  inputValue={accrItem.badge.url ?? ""}
                                  isVisible
                                  required
                                  onChangeInput={(value) => {
                                    setAddEducation((prev) => ({
                                      ...prev,
                                      newEducation: {
                                        ...prev.newEducation,
                                        newCoursesAndAccr:
                                          prev.newEducation.newCoursesAndAccr.map(
                                            (el, i) => ({
                                              ...el,
                                              accreditations:
                                                index !== i
                                                  ? el.accreditations
                                                  : el.accreditations.map(
                                                      (accrArray, accIndex) =>
                                                        accIndex !== idx
                                                          ? accrArray
                                                          : {
                                                              ...accrArray,
                                                              badge: {
                                                                ...accrArray.badge!,
                                                                url: value,
                                                              },
                                                            },
                                                    ),
                                            }),
                                          ),
                                      },
                                    }));
                                  }}
                                  border={
                                    validateURL(accrItem.badge.url) ||
                                    !accrItem.badge.url ||
                                    !accrItem.badge.url.length
                                      ? "none"
                                      : "1px solid red"
                                  }
                                  placeholder="https://www.credly.com/org/international-coach-federation/badge/icf-member-badge"
                                  margin="0"
                                />
                              )}
                            </div>
                          </td>
                          <td className={s.td}>
                            <div
                              className={s.rowBeetween}
                              style={{ margin: 0 }}
                            >
                              <MuiSwitch
                                checked={accrItem.isShown ?? false}
                                setChecked={(value) =>
                                  setAddEducation((prev) => ({
                                    ...prev,
                                    newEducation: {
                                      ...prev.newEducation,
                                      newCoursesAndAccr:
                                        prev.newEducation.newCoursesAndAccr.map(
                                          (el, i) => ({
                                            ...el,
                                            accreditations:
                                              index !== i
                                                ? el.accreditations
                                                : el.accreditations.map(
                                                    (accrArray, accIndex) =>
                                                      accIndex !== idx
                                                        ? accrArray
                                                        : {
                                                            ...accrArray,
                                                            isShown: value,
                                                          },
                                                  ),
                                          }),
                                        ),
                                    },
                                  }))
                                }
                              />
                              <div
                                onClick={() =>
                                  setAddEducation((prev) => ({
                                    ...prev,
                                    newEducation: {
                                      ...prev.newEducation,
                                      newCoursesAndAccr:
                                        prev.newEducation.newCoursesAndAccr.map(
                                          (courseItem, courseIndex) => {
                                            if (index === courseIndex) {
                                              return {
                                                ...courseItem,
                                                accreditations:
                                                  courseItem.accreditations.filter(
                                                    (_, accrIndex) =>
                                                      idx !== accrIndex,
                                                  ),
                                              };
                                            } else return courseItem;
                                          },
                                        ),
                                    },
                                  }))
                                }
                              >
                                <DeleteIcon className={s.deleteAccrIcon} />
                              </div>
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            ))}
          {addEducation.newEducation.prevCourseAndAccr &&
            addEducation.newEducation.prevCourseAndAccr
              .filter((el) => !el.deleted)
              .map((item, index) => (
                <div className={s.courseAccrElement} key={item._id}>
                  <div
                    className={s.deleteBtn}
                    onClick={() => {
                      setAddEducation((prev) => ({
                        ...prev,
                        newEducation: {
                          ...prev.newEducation,
                          prevCourseAndAccr:
                            prev.newEducation.prevCourseAndAccr!.map(
                              (courseToDelete, courseToDeleteIndex) => {
                                if (courseToDeleteIndex === index) {
                                  return { ...courseToDelete, deleted: true };
                                } else return courseToDelete;
                              },
                            ),
                        },
                      }));
                    }}
                  >
                    <DeleteIcon className={s.closeIcon} />
                  </div>
                  <div className={s.flex20Gap} style={{ marginTop: "20px" }}>
                    <Input
                      inputValue={
                        item.text.find((el) => el.language === selecLangForText)
                          ?.text || ""
                      }
                      isVisible
                      required
                      placeholder={getPlaceHolder(item.text)}
                      width="80%"
                      onChangeInput={(value) =>
                        setAddEducation((prev) => ({
                          ...prev,
                          newEducation: {
                            ...prev.newEducation,
                            prevCourseAndAccr:
                              prev.newEducation.prevCourseAndAccr!.map(
                                (el, i) => ({
                                  ...el,
                                  text:
                                    index !== i
                                      ? el.text
                                      : el.text.map((textItem) => {
                                          if (
                                            textItem.language ===
                                            selecLangForText
                                          ) {
                                            return {
                                              text: value,
                                              language: textItem.language,
                                            };
                                          } else return textItem;
                                        }),
                                }),
                              ),
                          },
                        }))
                      }
                      lable={"Course title"}
                      margin="0"
                    />
                    <div>
                      <span className={s.secondLable}>Is verified course?</span>
                      <MuiSwitch
                        checked={item.isShown}
                        setChecked={(value) =>
                          setAddEducation((prev) => ({
                            ...prev,
                            newEducation: {
                              ...prev.newEducation,
                              prevCourseAndAccr:
                                prev.newEducation.prevCourseAndAccr!.map(
                                  (el) => {
                                    if (el._id === item._id) {
                                      return {
                                        ...el,
                                        isShown: value,
                                      };
                                    }
                                    return el;
                                  },
                                ),
                            },
                          }))
                        }
                      />
                    </div>
                  </div>
                  <div className={s.flex20Gap} style={{ margin: "15px 0" }}>
                    <span className={s.blockLabel}>Accreditations</span>{" "}
                    <div
                      className={s.addAccrBtn}
                      onClick={() =>
                        setNewAccrForPrevCourses((prev) =>
                          prev
                            ? [
                                ...prev,
                                {
                                  courseId: item._id,
                                  text: emptyMultiLangStrings,
                                  isShown: true,
                                },
                              ]
                            : [
                                {
                                  courseId: item._id,
                                  text: emptyMultiLangStrings,
                                  isShown: true,
                                },
                              ],
                        )
                      }
                    >
                      <PlusIcon />
                    </div>
                  </div>
                  <table className={s.table}>
                    <thead className={s.thead}>
                      <tr>
                        <th className={s.th}>Title</th>
                        <th className={s.th}>Badge</th>
                        <th className={s.th}>Is Verified</th>
                      </tr>
                    </thead>
                    <tbody>
                      {item.accreditations &&
                        item.accreditations
                          .filter((el) => !el!.deleted)
                          .map((accrItem, idx) => (
                            <tr key={idx}>
                              <td className={s.td}>
                                {" "}
                                <Input
                                  inputValue={
                                    accrItem?.text.find(
                                      (el) => el.language === selecLangForText,
                                    )?.text || ""
                                  }
                                  isVisible
                                  required
                                  placeholder={getPlaceHolder(
                                    accrItem?.text ?? [],
                                  )}
                                  onChangeInput={(value) => {
                                    const newAccreditations =
                                      item.accreditations.map(
                                        (accrEl, valueAccrIndex) => ({
                                          ...accrEl!,
                                          text:
                                            valueAccrIndex !== idx
                                              ? accrEl!.text
                                              : accrEl!.text.map((textItem) => {
                                                  if (
                                                    textItem.language ===
                                                    selecLangForText
                                                  ) {
                                                    return {
                                                      text: value,
                                                      language:
                                                        textItem.language,
                                                    };
                                                  } else return textItem;
                                                }),
                                        }),
                                      );
                                    setAddEducation((prev) => ({
                                      ...prev,
                                      newEducation: {
                                        ...prev.newEducation,
                                        prevCourseAndAccr:
                                          prev.newEducation.prevCourseAndAccr!.map(
                                            (prevCourses, prevIndex) => {
                                              if (index !== prevIndex)
                                                return prevCourses;
                                              else
                                                return {
                                                  ...prevCourses,
                                                  accreditations:
                                                    newAccreditations,
                                                };
                                            },
                                          ),
                                      },
                                    }));
                                  }}
                                  margin="10px 0"
                                />
                              </td>
                              <td className={s.td}>
                                <div className={s.uploadFilesActionBlock}>
                                  <div>
                                    {getBadgeForAccrToUpdate(
                                      item._id,
                                      accrItem!._id,
                                    )?.file && (
                                      <img
                                        src={
                                          typeof getBadgeForAccrToUpdate(
                                            item._id,
                                            accrItem!._id,
                                          )?.file === "string"
                                            ? (getBadgeForAccrToUpdate(
                                                item._id,
                                                accrItem!._id,
                                              )?.file as string)
                                            : URL.createObjectURL(
                                                getBadgeForAccrToUpdate(
                                                  item._id,
                                                  accrItem!._id,
                                                )?.file as File,
                                              )
                                        }
                                        alt=""
                                        className={s.badgeIcon}
                                      />
                                    )}
                                  </div>
                                  <label className={s.fileInputBlock}>
                                    <input
                                      style={{ display: "none" }}
                                      type="file"
                                      accept={imageExtensions.join(", ")}
                                      multiple
                                      onChange={(e) =>
                                        handleBadgeIconChange(
                                          e,
                                          (file: File) => {
                                            if (accrItem?.badge) {
                                              setBadgesToUpdate((prev) => ({
                                                ...prev,
                                                [accrItem.badge!._id]: {
                                                  ...prev[accrItem.badge!._id],
                                                  file: file,
                                                },
                                              }));
                                              return;
                                            }
                                            setNewBadgesForPrevAccr((prev) => [
                                              ...prev.filter(
                                                (el) =>
                                                  el.accrId !== accrItem?._id,
                                              ),
                                              {
                                                accrId: accrItem!._id,
                                                file: file,
                                              },
                                            ]);
                                          },
                                        )
                                      }
                                    />
                                    {getBadgeForAccrToUpdate(
                                      item._id,
                                      accrItem!._id,
                                    ) ? (
                                      <span
                                        className={s.updateAvatarBtn}
                                        role="button"
                                      >
                                        <span>Replace</span>
                                      </span>
                                    ) : (
                                      <div className={s.addCertificateBtn}>
                                        <PlusIcon className={s.plusIcon} />
                                        <span>Add badge</span>
                                      </div>
                                    )}
                                  </label>
                                  {getBadgeForAccrToUpdate(
                                    item._id,
                                    accrItem!._id,
                                  ) && (
                                    <Input
                                      inputValue={
                                        getBadgeForAccrToUpdate(
                                          item._id,
                                          accrItem!._id,
                                        )?.url || ""
                                      }
                                      isVisible
                                      required
                                      onChangeInput={(value) => {
                                        if (accrItem?.badge) {
                                          setBadgesToUpdate((prev) => ({
                                            ...prev,
                                            [accrItem.badge!._id]: {
                                              file: prev[accrItem.badge!._id]
                                                ? prev[accrItem.badge!._id].file
                                                : accrItem.badge?.link,
                                              url: value,
                                              _id: accrItem.badge?._id!,
                                            },
                                          }));
                                          return;
                                        }
                                        setNewBadgesForPrevAccr((prev) =>
                                          prev.map((item) => {
                                            if (item.accrId === accrItem?._id) {
                                              return { ...item, url: value };
                                            }
                                            return item;
                                          }),
                                        );
                                      }}
                                      border={
                                        validateURL(
                                          getBadgeForAccrToUpdate(
                                            item._id,
                                            accrItem!._id,
                                          )?.url,
                                        ) ||
                                        !getBadgeForAccrToUpdate(
                                          item._id,
                                          accrItem!._id,
                                        )?.url ||
                                        !getBadgeForAccrToUpdate(
                                          item._id,
                                          accrItem!._id,
                                        )?.url?.length
                                          ? "none"
                                          : "1px solid red"
                                      }
                                      placeholder="https://www.credly.com/org/international-coach-federation/badge/icf-member-badge"
                                      margin="0"
                                    />
                                  )}
                                </div>
                              </td>
                              <td className={s.td}>
                                <div
                                  className={s.rowBeetween}
                                  style={{ margin: 0 }}
                                >
                                  <MuiSwitch
                                    checked={accrItem!.isShown ?? false}
                                    setChecked={(value) => {
                                      const newAccreditations =
                                        item.accreditations.map(
                                          (accrEl, valueAccrIndex) => ({
                                            ...accrEl!,
                                            isShown:
                                              valueAccrIndex !== idx
                                                ? accrEl!.isShown
                                                : value,
                                          }),
                                        );
                                      setAddEducation((prev) => ({
                                        ...prev,
                                        newEducation: {
                                          ...prev.newEducation,
                                          prevCourseAndAccr:
                                            prev.newEducation.prevCourseAndAccr!.map(
                                              (prevCourses, prevIndex) => {
                                                if (index !== prevIndex)
                                                  return prevCourses;
                                                else
                                                  return {
                                                    ...prevCourses,
                                                    accreditations:
                                                      newAccreditations,
                                                  };
                                              },
                                            ),
                                        },
                                      }));
                                    }}
                                  />
                                  <div
                                    onClick={() =>
                                      setAddEducation((prev) => ({
                                        ...prev,
                                        newEducation: {
                                          ...prev.newEducation,
                                          prevCourseAndAccr:
                                            prev.newEducation.prevCourseAndAccr!.map(
                                              (courseItem, courseIndex) => {
                                                if (index === courseIndex) {
                                                  return {
                                                    ...courseItem!,
                                                    accreditations:
                                                      courseItem.accreditations!.map(
                                                        (
                                                          accrItemToDelete,
                                                          accrIndexToDelete,
                                                        ) => {
                                                          if (
                                                            accrIndexToDelete ===
                                                            idx
                                                          ) {
                                                            return {
                                                              ...accrItemToDelete!,
                                                              deleted: true,
                                                            };
                                                          } else
                                                            return accrItemToDelete!;
                                                        },
                                                      ),
                                                  };
                                                } else return courseItem;
                                              },
                                            ),
                                        },
                                      }))
                                    }
                                  >
                                    <DeleteIcon className={s.deleteAccrIcon} />
                                  </div>{" "}
                                </div>
                              </td>
                            </tr>
                          ))}
                      {newAccrForPrevCourses &&
                        newAccrForPrevCourses
                          .filter((el) => el.courseId === item._id)
                          .map((accrItem, idx) => (
                            <tr key={idx}>
                              <td className={s.td}>
                                {" "}
                                <Input
                                  inputValue={
                                    accrItem.text.find(
                                      (el) => el.language === selecLangForText,
                                    )?.text ?? ""
                                  }
                                  isVisible
                                  required
                                  placeholder={getPlaceHolder(
                                    accrItem?.text ?? [],
                                  )}
                                  onChangeInput={(value) => {
                                    setNewAccrForPrevCourses((prev) =>
                                      prev!.map((newAccrEl, newAccrIndex) => {
                                        if (newAccrIndex === idx)
                                          return {
                                            ...newAccrEl,
                                            text: newAccrEl.text.map(
                                              (accLangEl) => {
                                                if (
                                                  accLangEl.language ===
                                                  selecLangForText
                                                )
                                                  return {
                                                    ...accLangEl,
                                                    text: value,
                                                  };
                                                else return accLangEl;
                                              },
                                            ),
                                          };
                                        else return newAccrEl;
                                      }),
                                    );
                                  }}
                                  margin="10px 0"
                                />
                              </td>
                              <td className={s.td}>
                                <div className={s.uploadFilesActionBlock}>
                                  <div>
                                    {accrItem.badge && (
                                      <img
                                        src={
                                          typeof accrItem.badge === "string"
                                            ? url(
                                                `${connectionString}specialists/`,
                                                specialists.getFederationBadgeStream,
                                                { id: accrItem.badge },
                                              )
                                            : URL.createObjectURL(
                                                accrItem.badge.file,
                                              )
                                        }
                                        alt=""
                                        className={s.badgeIcon}
                                      />
                                    )}
                                  </div>
                                  <label className={s.fileInputBlock}>
                                    <input
                                      style={{ display: "none" }}
                                      type="file"
                                      accept={imageExtensions.join(", ")}
                                      multiple
                                      onChange={(e) =>
                                        handleBadgeIconChange(
                                          e,
                                          (file: File) => {
                                            setNewAccrForPrevCourses((prev) =>
                                              prev!.map(
                                                (newAccrEl, newAccrIndex) => {
                                                  if (newAccrIndex === idx)
                                                    return {
                                                      ...newAccrEl,
                                                      badge: {
                                                        file: file,
                                                      },
                                                    };
                                                  else return newAccrEl;
                                                },
                                              ),
                                            );
                                          },
                                        )
                                      }
                                    />
                                    {accrItem.badge ? (
                                      <span
                                        className={s.updateAvatarBtn}
                                        role="button"
                                      >
                                        <span>Replace</span>
                                      </span>
                                    ) : (
                                      <div className={s.addCertificateBtn}>
                                        <PlusIcon className={s.plusIcon} />
                                        <span>Add badge</span>
                                      </div>
                                    )}
                                  </label>
                                  {accrItem.badge && (
                                    <Input
                                      inputValue={accrItem.badge.url ?? ""}
                                      isVisible
                                      required
                                      onChangeInput={(value) => {
                                        setNewAccrForPrevCourses((prev) =>
                                          prev!.map(
                                            (newAccrEl, newAccrIndex) => {
                                              if (newAccrIndex === idx)
                                                return {
                                                  ...newAccrEl,
                                                  badge: {
                                                    ...newAccrEl.badge!,
                                                    url: value,
                                                  },
                                                };
                                              else return newAccrEl;
                                            },
                                          ),
                                        );
                                      }}
                                      border={
                                        validateURL(accrItem.badge.url) ||
                                        !accrItem.badge.url ||
                                        !accrItem.badge.url.length
                                          ? "none"
                                          : "1px solid red"
                                      }
                                      placeholder="https://www.credly.com/org/international-coach-federation/badge/icf-member-badge"
                                      margin="0"
                                    />
                                  )}
                                </div>
                              </td>
                              <td className={s.td}>
                                <div
                                  className={s.rowBeetween}
                                  style={{ margin: 0 }}
                                >
                                  <MuiSwitch
                                    checked={accrItem!.isShown ?? false}
                                    setChecked={(value) => {
                                      setNewAccrForPrevCourses((prev) =>
                                        prev!.map((newAccrEl, newAccrIndex) => {
                                          if (newAccrIndex === idx)
                                            return {
                                              ...newAccrEl,
                                              isShown: value,
                                            };
                                          else return newAccrEl;
                                        }),
                                      );
                                    }}
                                  />
                                  <div
                                    onClick={() =>
                                      setNewAccrForPrevCourses((prev) =>
                                        prev!.filter((_, i) => idx !== i),
                                      )
                                    }
                                  >
                                    <DeleteIcon className={s.deleteAccrIcon} />
                                  </div>
                                </div>
                              </td>
                            </tr>
                          ))}
                    </tbody>
                  </table>
                </div>
              ))}
        </div>
      </div>
      <div className={s.saveBtnBlock}>
        <StandartButton
          action={educationToUpdate ? updateEducation : saveEducation}
          buttonTitle={"Save"}
          width="300px"
          disabled={!validationNewCertificate()}
        />
      </div>
    </div>
  );
};

export default EducationsCertificates;
